import React from 'react';
import { Form, Input, Card } from 'antd';
import WeekdayRuleContent from './WeekdayRuleContent';
import HourlyRate from './HourlyRate';


interface PropsType {
  enums?: any
}

const TemplateSelect:React.FC<PropsType> = (props) => {
  const { enums } = props;

  return (
    <>
      <Form.Item
        label="模板名称"
        name="name"
        labelCol={{
            style: { width: '80px' }
        }}
        labelAlign='left'
        rules={[{ required: true, message: "请输入模板名称" }]}
      >
        <Input style={{width: '500px'}} placeholder="请输入模板名称" />
      </Form.Item>

      <Form.Item
        label=""
        name={['weekday', 'is_free_cancel_or_pickup_home']}
      >
        <WeekdayRuleContent />
      </Form.Item>
      <HourlyRate enums={enums} />
    </>
  )
}




export default TemplateSelect;
